import { DateTime } from 'luxon';
import { WorkflowRun } from '../types';

export const generateWorkflowRunTitle = (workflowRun: WorkflowRun) =>
    `${DateTime.fromISO(workflowRun.period.start_date).toFormat('dd LLL yyyy')} to ${DateTime.fromISO(workflowRun.period.end_date).toFormat(
        'dd LLL yyyy'
    )}`;
